module.exports = __webpack_public_path__ + "img/horizontal_2_1_3016.cb7cba8d.png";